var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "li",
    { staticClass: "nav-item dropdown d-none d-lg-flex align-items-center" },
    [
      _vm.isAdmin
        ? _c(
            "audio",
            {
              ref: "notification-audio",
              attrs: { "data-notification-audio": "" },
            },
            [
              _c("source", {
                attrs: { src: "/media/notification.mp3", type: "audio/mpeg" },
              }),
            ]
          )
        : _vm._e(),
      _c(
        "a",
        {
          staticClass: "nav-link dropdown-toggle px-2 notification-toggle",
          attrs: {
            "aria-expanded": "false",
            "aria-haspopup": "true",
            "data-toggle": "dropdown",
            href: "#",
            role: "button",
          },
        },
        [
          _c("font-awesome-icon", { attrs: { icon: ["fas", "bell"] } }),
          _vm.unreadClarifications && _vm.unreadClarifications.length > 0
            ? _c("span", { staticClass: "badge badge-danger count-badge" }, [
                _vm._v(_vm._s(_vm.unreadClarifications.length)),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "dropdown-menu dropdown-menu-right notification-dropdown",
        },
        [
          _vm.unreadClarifications.length === 0
            ? _c("div", { staticClass: "text-center" }, [
                _vm._v(
                  " " + _vm._s(_vm.T.notificationsNoNewNotifications) + " "
                ),
              ])
            : _vm._e(),
          _c(
            "transition-group",
            { attrs: { name: "list" } },
            _vm._l(_vm.unreadClarifications, function (clarification) {
              return _c(
                "div",
                {
                  key: clarification.clarification_id,
                  staticClass: "d-flex align-items-center flex-wrap px-4",
                  attrs: {
                    "data-clarification": clarification.clarification_id,
                  },
                },
                [
                  _c("hr", { staticClass: "w-100 my-2" }),
                  _c("div", { staticClass: "w-100 justify-content-between" }, [
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onCloseClicked(clarification)
                          },
                        },
                      },
                      [_vm._v(" ❌ ")]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-100 align-items-center pt-1 notification-link",
                    },
                    [
                      _c(
                        "a",
                        { attrs: { href: _vm.anchor(clarification) } },
                        [
                          _c("span", [
                            _vm._v(_vm._s(clarification.problem_alias)),
                          ]),
                          _vm._v(" — "),
                          _c("span", [_vm._v(_vm._s(clarification.author))]),
                          _c("pre", [_vm._v(_vm._s(clarification.message))]),
                          clarification.answer
                            ? [
                                _c("hr"),
                                _c("pre", [
                                  _vm._v(_vm._s(clarification.answer)),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
          _vm.unreadClarifications && _vm.unreadClarifications.length > 1
            ? [
                _c("li", {
                  staticClass: "divider",
                  attrs: { role: "separator" },
                }),
                _c("li", { attrs: { "data-mark-all-as-read-button": "" } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onMarkAllAsRead.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fas", "align-right"] },
                      }),
                      _vm._v(" " + _vm._s(_vm.T.notificationsMarkAllAsRead)),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }